import React from "react";
import {
  StatusCssClasses,
  StatusTitles
} from "../UIHelpers";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
export const StatusColumnFormatter = (cellContent, row, rowIndex, { statusChange }) => (
  // row.isActive ?
  //   <span
  //     className={`label label-lg label-light-${StatusCssClasses[0]
  //       } label-inline`}
  //   >
  //     {StatusTitles[0]}
  //   </span>
  //   :
  //   <span
  //     className={`label label-lg label-light-${StatusCssClasses[1]
  //       } label-inline`}
  //   >
  //     {StatusTitles[1]}
  //   </span>
  <>
    {statusChange && (
      <OverlayTrigger
        overlay={<Tooltip id="products-delete-tooltip">Status</Tooltip>}
      >
        <span className="switch switch-primary switch-icon">
          <label>
            <input onChange={() => statusChange(row)} type="checkbox" checked={row.isActive || row.is_show_in_store} name="isActive" />
            <span></span>
          </label>
        </span>
        {/* <a
        className="btn btn-icon btn-light btn-hover-primary btn-sm"
        onClick={() => statusChange(row._id)}
      >
        <span className="svg-icon svg-icon-md svg-icon-primary">
          <SVG src={toAbsoluteUrl("/media/svg/icons/General/Visible.svg")} />
        </span>
      </a> */}
      </OverlayTrigger>
    )}
  </>
);
